import { MenuItem } from '@material-ui/core';
import React from 'react';

import { DetailsLabel, SettingsContainer, SettingsSelect } from './BranchComponents';
import Switch from '../../Shared/Switch';
import InactiveOrderingSetting from '../InactiveOrderingSettings/InactiveOrderingSetting';

const IntegrationSettings = ({ pharmacy, onChange }) => {
  const { docman_enabled, controlled_workflow, allow_messaging, status } = pharmacy;

  const createSwitchChangeHandler = field => (_, checked) => {
    if (field) {
      onChange(field, checked);
    }
  };

  const createDropdownChangeHandler = field => e => {
    const { value } = e?.target;

    if (field) {
      onChange(field, value);
    }
  };

  return (
    <SettingsContainer>
      <Switch
        label="Messaging"
        onChange={createSwitchChangeHandler('allow_messaging')}
        checked={!!allow_messaging}
      />
      <DetailsLabel>Status</DetailsLabel>
      <SettingsSelect onChange={createDropdownChangeHandler('status')} value={status}>
        <MenuItem value="undefined" disabled>Not selected</MenuItem>
        <MenuItem value="free">Free</MenuItem>
        <MenuItem value="premium">Premium</MenuItem>
        <MenuItem value="inactive">Inactive</MenuItem>
        <MenuItem value="archived">Archived</MenuItem>
      </SettingsSelect>
      <Switch
        label="Integration"
        onChange={createSwitchChangeHandler('docman_enabled')}
        checked={!!docman_enabled}
        value={!!docman_enabled}
      />
      <Switch
        label="Controlled workflow"
        onChange={createSwitchChangeHandler('controlled_workflow')}
        checked={!!controlled_workflow}
        value={!!controlled_workflow}
      />
      <InactiveOrderingSetting pharmacy={pharmacy} />
    </SettingsContainer>
  );
};

export default IntegrationSettings;
